import '../styles/main.css';

const Main = () => (
  <>
    <h1 id="title-h1">Front-end Developer Test Project</h1>
    <p>
      my Goal is to make a page that looks exactly like
      {' '}
      <a href="https://www.figma.com/file/tw8CNEl69jYeqPHxfBxf38/Helpjuice-Front-End-Developer-Test-Project?node-id=0%3A1"> this one</a>
      {' '}
      an has the ability to create h1 text simply by tipying / then 1,
      then typying text, and hitting enter
      {' '}
    </p>
  </>
);

export default Main;
